/* eslint-disable */
import {Injectable} from '@angular/core';
import {OrderField} from '../../query/orderfields';
import {OrderFieldModel, OrderFunctionResolver} from '../../../util/core-utils';
import {NewBaseSearch, NewBaseSearchService} from '../../new-base.search-service';
import {OrderType} from '../../util/services';
import {SearchUtils} from '../../../util/search-utils';
import {NgbDateStruct} from '@ng-bootstrap/ng-bootstrap';
import {LoggedInUserStorage} from '../../util/storages';

/* eslint-enable */

@Injectable()
export class TaskRecordOutgoingSmsSearchService extends NewBaseSearchService<OrderField.OutgoingSms> {

  protected createStorage(): TaskRecordOutgoingSmsSearch.Storage {
    return new TaskRecordOutgoingSmsSearch.Storage();
  }

}

export namespace TaskRecordOutgoingSmsSearch {

  export class Model extends SearchUtils.SearchModel {

    showSearch: boolean = false;

    deliveryTimeFrom: NgbDateStruct | null;
    deliveryTimeTo: NgbDateStruct | null;
    bipStateTimestampFrom: NgbDateStruct | null;
    bipStateTimestampTo: NgbDateStruct | null;
    messageId: string;

    constructor() {
      super();
      this.reset();
    }

    reset() {
      this.deliveryTimeFrom = null;
      this.deliveryTimeTo = null;
      this.bipStateTimestampFrom = null;
      this.bipStateTimestampTo = null;
      this.messageId = '';
    }

    isEmpty(): boolean {
      return this.messageId === '' &&
        this.deliveryTimeFrom === null &&
        this.deliveryTimeTo === null &&
        this.bipStateTimestampFrom === null &&
        this.bipStateTimestampTo === null;
    }

  }

  export namespace OrderFunctions {
    export const ID = (f: OrderField.OutgoingSms) => f.id;
    export const DELIVERY_TIME = (f: OrderField.OutgoingSms) => f.deliveryTime;
    export const MESSAGE_ID = (f: OrderField.OutgoingSms) => f.messageId;

    export const VALUES = OrderFunctionResolver.builder<OrderField.OutgoingSms>()
      .add(ID, 'id')
      .add(DELIVERY_TIME, 'delivery_time')
      .add(MESSAGE_ID, 'message_id')
      .build();
  }

  export interface SearchDataResult {
    searchData: SearchData;
  }

  export interface SearchData extends NewBaseSearch.SearchData<OrderField.OutgoingSms> {
    searchModel: Model;
  }

  interface StoredSearchRawData extends NewBaseSearch.StoredSearchRawData<OrderField.OutgoingSms> {
    deliveryTimeFrom: NgbDateStruct | null;
    deliveryTimeTo: NgbDateStruct | null;
    bipStateTimestampFrom: NgbDateStruct | null;
    bipStateTimestampTo: NgbDateStruct | null;
    messageId: string;
  }

  export class Storage extends NewBaseSearch.Storage<OrderField.OutgoingSms> {

    constructor() {
      const defaultSearchData: SearchData = {
        queryModel: new OrderFieldModel(OrderFunctions.ID, OrderType.DESC),
        searchModel: new Model(),
      };
      /**
       * Increment this version if you change the SearchData interface.
       */
      const versionNumber: number = 3;
      super(defaultSearchData,
        versionNumber);
    }

    protected generateKey(): string {
      return 'UserId(' + LoggedInUserStorage.getInstance().getUserId() + ')-Search-TaskRecord-Outgoing-Sms';
    }

    protected fromRaw(data: StoredSearchRawData): NewBaseSearch.SearchDataResult<OrderField.OutgoingSms> {
      const searchModel = new Model();
      searchModel.deliveryTimeFrom = data.deliveryTimeFrom;
      searchModel.deliveryTimeTo = data.deliveryTimeTo;
      searchModel.bipStateTimestampFrom = data.bipStateTimestampFrom;
      searchModel.bipStateTimestampTo = data.bipStateTimestampTo;
      searchModel.messageId = data.messageId;
      const searchData: SearchData = {
        queryModel: OrderFieldModel.create<OrderField.OutgoingSms>(OrderFunctions.VALUES, data.order, data.queryModel),
        searchModel: searchModel,
      };
      return {
        searchData: searchData
      };
    }

    protected toRaw(data: SearchData): StoredSearchRawData {
      return {
        version: this.VERSION,
        queryModel: data.queryModel,
        order: data.queryModel.createOrder(OrderFunctions.VALUES),
        deliveryTimeFrom: data.searchModel.deliveryTimeFrom,
        deliveryTimeTo: data.searchModel.deliveryTimeTo,
        bipStateTimestampFrom: data.searchModel.bipStateTimestampFrom,
        bipStateTimestampTo: data.searchModel.bipStateTimestampTo,
        messageId: data.searchModel.messageId,
      };
    }

  }

}
